import { Controller } from "@hotwired/stimulus"

// Controller: session-blocks-planner
// Usage: container has data-controller and data-*-reorder-url-value, list items with data-id and draggable=true
export default class extends Controller {
  static targets = ["list"]
  static values = {
    reorderUrl: String
  }

  connect() {
    this.draggedEl = null
    this.listTarget.addEventListener("dragstart", this.onDragStart)
    this.listTarget.addEventListener("dragover", this.onDragOver)
    this.listTarget.addEventListener("drop", this.onDrop)
    this.listTarget.addEventListener("dragend", this.onDragEnd)
  }

  disconnect() {
    this.listTarget.removeEventListener("dragstart", this.onDragStart)
    this.listTarget.removeEventListener("dragover", this.onDragOver)
    this.listTarget.removeEventListener("drop", this.onDrop)
    this.listTarget.removeEventListener("dragend", this.onDragEnd)
  }

  onDragStart = (event) => {
    const li = event.target.closest("li[draggable='true']")
    if (!li) return
    this.draggedEl = li
    event.dataTransfer.effectAllowed = "move"
    li.classList.add("ring", "ring-primary")
  }

  onDragOver = (event) => {
    event.preventDefault() // allow drop
    if (!this.draggedEl) return
    const afterElement = this.getDragAfterElement(event.clientY)
    if (afterElement == null) {
      this.listTarget.appendChild(this.draggedEl)
    } else if (afterElement !== this.draggedEl) {
      this.listTarget.insertBefore(this.draggedEl, afterElement)
    }
  }

  onDrop = (event) => {
    event.preventDefault()
  }

  onDragEnd = () => {
    if (this.draggedEl) {
      this.draggedEl.classList.remove("ring", "ring-primary")
    }
    this.draggedEl = null
  }

  getDragAfterElement(y) {
    const draggableElements = [...this.listTarget.querySelectorAll("li[draggable='true']")]
      .filter(el => el !== this.draggedEl)

    return draggableElements.reduce((closest, child) => {
      const box = child.getBoundingClientRect()
      const offset = y - box.top - box.height / 2
      if (offset < 0 && offset > closest.offset) {
        return { offset: offset, element: child }
      } else {
        return closest
      }
    }, { offset: Number.NEGATIVE_INFINITY }).element
  }

  saveOrder = async () => {
    const ids = [...this.listTarget.querySelectorAll("li[draggable='true']")]
      .map(li => li.dataset.id)

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.reorderUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": token
        },
        body: JSON.stringify({ order: ids })
      })

      if (response.ok) {
        window.location.reload()
      } else {
        // Fallback: redirect to let server show alert
        window.location.href = this.reorderUrlValue + "?order=" + encodeURIComponent(ids.join(","))
      }
    } catch (e) {
      console.error("Failed to save order", e)
    }
  }
}
